var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 0.9C10.8 0.402944 11.2029 0 11.7 0H15.3C16.0161 0 16.7028 0.284463 17.2092 0.790812C17.7155 1.29716 18 1.98392 18 2.7V15.3C18 16.0161 17.7155 16.7028 17.2092 17.2092C16.7028 17.7155 16.0161 18 15.3 18H11.7C11.2029 18 10.8 17.5971 10.8 17.1C10.8 16.6029 11.2029 16.2 11.7 16.2H15.3C15.5387 16.2 15.7676 16.1052 15.9364 15.9364C16.1052 15.7676 16.2 15.5387 16.2 15.3V2.7C16.2 2.46131 16.1052 2.23239 15.9364 2.0636C15.7676 1.89482 15.5387 1.8 15.3 1.8H11.7C11.2029 1.8 10.8 1.39706 10.8 0.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56358 3.86358C6.91505 3.51211 7.4849 3.51211 7.83637 3.86358L12.3364 8.36358C12.6878 8.71505 12.6878 9.2849 12.3364 9.63637L7.83637 14.1364C7.4849 14.4878 6.91505 14.4878 6.56358 14.1364C6.21211 13.7849 6.21211 13.2151 6.56358 12.8636L9.42717 10H0.857143C0.383756 10 0 9.55229 0 9C0 8.44771 0.383756 8 0.857143 8H9.42721L6.56358 5.13637C6.21211 4.7849 6.21211 4.21505 6.56358 3.86358Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIn);
export default __webpack_public_path__ + "static/media/icon_in.834c190cb6a872f5ef18557160e337c1.svg";
export { ForwardRef as ReactComponent };